import React, { Fragment } from "react";
import { Tab } from "@headlessui/react";
import LazyLoad from "react-lazy-load";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}
const TabGroup = ({ tabs, Case = false }) => {
  return (
    <section aria-label="project works list">
      <Tab.Group as="div" className="mt-4">
        <nav
          aria-label="header-section-of-all-projects"
          className="flex -mx-4 overflow-x-auto sm:mx-0"
        >
          <div className="flex-auto px-4 border  rounded-lg sm:rounded-none py-1.5 sm:py-0 mx-2  sm:border-0 sm:border-b  border-gray-200 sm:px-0">
            <Tab.List
              aria-label="nav-tabs-list"
              className="grid -mb-px sm:flex focus:outline-none sm:space-x-10"
            >
              {tabs.map((tab) => (
                <Tab
                  key={tab.id}
                  className={({ selected }) =>
                    classNames(
                      selected
                        ? "border-cyan-500 text-cyan-600"
                        : "border-transparent text-gray-200 hover:text-gray-400 hover:border-gray-300",
                      "whitespace-nowrap focus:outline-none text-left border-b-2 py-3 sm:py-6 text-sm font-medium"
                    )
                  }
                >
                  {tab.name}
                </Tab>
              ))}
            </Tab.List>
          </div>
        </nav>

        <Tab.Panels as={Fragment}>
          {tabs.map((tab) => (
            <Tab.Panel
              key={tab.id}
              className="min-w-full pt-10 space-y-16 lg:pt-16"
            >
              {tab.features.map((feature) => (
                <article
                  aria-label={feature.name}
                  key={feature.id}
                  className="flex flex-col-reverse lg:grid lg:grid-cols-12 lg:gap-x-8"
                >
                  <hgroup className="mt-6 lg:col-span-5 lg:mt-0">
                    <h3 className="text-lg font-semibold text-gray-100 ">
                      {feature.name}
                    </h3>
                    {feature.description.map((list) => (
                      <ul
                        aria-label="list of things in work"
                        key={list.id}
                        className="grid my-2 text-sm tracking-wider text-gray-200"
                      >
                        <li aria-label={list.point} className="">
                          {list.point}
                        </li>
                      </ul>
                    ))}
                    <div className="flex justify-center py-4 md:justify-end">
                      <a
                        aria-label={feature.url}
                        id={feature.name}
                        rel="exteranl noreferrer noopener"
                        title="github page"
                        target="_blank"
                        href={feature.url}
                        className="flex items-center justify-center text-white duration-300 border-2 rounded-lg hover:shadow-xl shadow-gray-900 h-14 w-60 text-md hover:text-lg hover:text-cyan-400 hover:underline underline-offset-4 text-bold"
                      >
                        {Case
                          ? "Check It Out Presentation"
                          : "Check it on GitHub"}
                      </a>
                    </div>
                  </hgroup>
                  <div className="lg:col-span-7">
                    <figure
                      aria-label={feature.imageAlt}
                      className="overflow-hidden bg-gray-100 rounded-lg aspect-w-2 aspect-h-1 sm:aspect-w-5 sm:aspect-h-2"
                    >
                      <LazyLoad>
                        <img
                          src={feature.imageSrc}
                          alt={feature.imageAlt}
                          className="object-cover object-center duration-200 hover:scale-110"
                        />
                      </LazyLoad>
                    </figure>
                  </div>
                </article>
              ))}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </Tab.Group>
    </section>
  );
};

export default TabGroup;
